module.exports = __webpack_public_path__ + "img/tree.b0c4b22a.png";